import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import _ from 'underscore';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { Button, Glyphicon } from '@bingads-webui-react/primitive';
import { getMenuItemStyles } from '../styles/menu-item-styles';

const GetNodeClassNames = (node, classes) => classNames([
  classes.baseMenuItem,
  node.isSelected ? [classes.selectedMenuItem, 'selected'] : classes.normalMenuItem,
  `menu-item-${node.Id}`,
]);

const ConnectionItem = ({
  classes,
  node,
  renderText,
  onItemClick,
  isExpanded,
}) => {
  const cnames = classNames([GetNodeClassNames(node, classes)]);

  const icon = 'ba-RadioBullet2';
  let iconStatusClassName = '';

  if (node.Status === 'Enabled') {
    iconStatusClassName = classes.activeStatusIcon;
  } else if (node.Status === 'Paused') {
    iconStatusClassName = classes.pendingStatusIcon;
  } else if (node.Status === 'Expired') {
    iconStatusClassName = classes.rejectedStatusIcon;
  }

  return (
    <Button
      key={node.Id}
      className={cnames}
      btnStyle="command"
      onClick={() => onItemClick(node)}
      aria-label={node.Name}
    >
      {node.isSelected && <div className={classes.beforeIcon} />}
      {isExpanded ?
        <div className={classes.iconContainer}>
          <Glyphicon
            id={`${icon}-icon`}
            className={iconStatusClassName}
            glyph={icon}
          />
        </div>
      :
        <div className={classes.connectionIconContainer}>
          <div className={node.isSelected ? classes.selectedCollapsedConnectionIcon : classes.collapsedConnectionIcon}>
            {node.Account}
          </div>
        </div>
      }
      {renderText && <span className={classNames(classes.textContainer, 'type-name')}>{renderText}</span>}
    </Button>
  );
};

ConnectionItem.defaultProps = {
  renderText: null,
};

ConnectionItem.propTypes = {
  classes: PropTypes.shape(_.mapObject(
    getMenuItemStyles({}, {}),
    _.constant(PropTypes.string.isRequired)
  )).isRequired,
  isExpanded: PropTypes.bool.isRequired,
  node: PropTypes.shape({
    Id: PropTypes.number,
    Name: PropTypes.string,
    isSelected: PropTypes.bool,
    Status: PropTypes.string,
  }).isRequired,
  renderText: PropTypes.string,
  onItemClick: PropTypes.func.isRequired,
};

export default withDefaultStyles(ConnectionItem, getMenuItemStyles);
